import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Login as View } from '@views';
import { LOADING, SUCCESS, FAILURE } from '@constants/requestPhase';
import { submitLogin } from '@store/menu/duck';
import { routes } from '@constants';
import { isClientError } from '@helpers/errorHandling';

const Login = () => {
  const { submitLoginPhase, submitLoginError } = useSelector(store => store.menu);

  const [password, setPassword] = useState('');
  const [hasServerError, setHasServerError] = useState(false);
  const [error, setError] = useState('');

  const dispatch = useDispatch();
  const history = useHistory();

  const handleToastClose = () => {
    setHasServerError(false);
  };

  const handlePasswordChange = e => {
    setPassword(e.target.value);
  };

  const handleLoginSubmit = () => {
    dispatch(submitLogin({
      adminId: 1,
      password,
    }));
  };

  useEffect(() => {
    if (submitLoginPhase === SUCCESS) {
      history.push(routes.menu);
    } else if (submitLoginPhase === FAILURE) {
      if (isClientError(submitLoginError && submitLoginError.data.status)) { // Case when we get 4** error
        setError(submitLoginError.data.error);
      } else {
        setHasServerError(true);
      }
    }
  }, [submitLoginPhase]);

  return (
    <View
      onToastClose={handleToastClose}
      hasServerError={hasServerError}
      isLoading={submitLoginPhase === LOADING}
      error={error}
      password={password}
      onPasswordChange={handlePasswordChange}
      onLoginSubmit={handleLoginSubmit}
    />
  );
};

export default Login;
